/**
 * -- MAIN.JS --
 * This file is the main entry point for Vite.
 * It imports styles automatically via glob patterns in styles.js.
 * Mixins are automatically available via vite.config.js preprocessorOptions.
 * This theme also includes AlpineJS and HTMX.
 */

import 'vite/modulepreload-polyfill';
import './styles/styles.js';

// Import required CSS for libraries
import '@glidejs/glide/dist/css/glide.core.min.css';
import '@glidejs/glide/dist/css/glide.theme.min.css';

// Import libraries
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse'
import htmx from 'htmx.org';
import jQuery from 'jquery';

// Make jQuery available globally for legacy code
window.$ = window.jQuery = jQuery;

// Import JS files
import './js/app.js';
import './js/main.js';
import './js/quick-search.js';
import './js/custom-search.js';
import './js/profile-dropdown.js';
import './js/cart-dropdown.js';

// Alpine JS
window.Alpine = Alpine;
Alpine.plugin(collapse);
Alpine.start();
import './js/alpine-stores';

// HTMX
window.htmx = htmx;

// Testing
document.addEventListener('DOMContentLoaded', () => { 
  console.log('Vite files loaded');
});